import React, { useContext } from 'react'; 
import Context from '../../../Context';
import {
    
    Switch,
    Route,    
    useRouteMatch
  } from "react-router-dom";
import LicenseText from './LicenseText';
import UserGuide from './UserGuide';

    function Docs(){    
        const cx=useContext(Context);
        cx.breadCrumbsAdd('Ship Safety','/ship-safety'); 
        let { path } = useRouteMatch();    
        return(           
            <div className="d-flex flex-column-fluid">				 
				<div className="container"> 
                    <Switch>
                        <Route exact path={path}>
                            <div className="card card-custom gutter-b">            
                                <div className="card-body">
                                    Основной внутренний раздел
                                </div>
                            </div>
                        </Route>
                        <Route path={`${path}/license`}>
                            <LicenseText/>                            
                        </Route>
                        <Route path={`${path}/guide`}>
                            <UserGuide/>                    
                        </Route>
                    </Switch>
                </div>
            </div>
        );
    }

export default Docs;